<template>
    <div class="saveUpdate">
        <el-dialog :close-on-click-modal="false" title="修改个人信息" :visible.sync="showDialog" @close="$emit('update:showUpdate', false)" :showUpdate="showUpdate" width="500px">
            <el-form :model="DetailInfo" ref="saveChn" label-width="60px">
                <el-form-item label="昵称：">
                    <el-input maxlength="12" v-model="DetailInfo.nickname" placeholder="请输入昵称（长度不超过12个字）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="$emit('update:showUpdate', false)" size="small">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="saveDetail" size="small" :disabled="fullscreenLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { updateAgencyMenber } from '@/api/index'
export default {
    data() {
        return {
            showDialog: this.showUpdate,
            loading: false,
            DetailInfo: {},
            newavatar: null,
            fullscreenLoading: false
        }
    },
    props: {
        showUpdate: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number
        },
        MerchantType: {
            type: Object
        },
        settleCycle: {
            type: Object
        }
    },
    created() {},
    methods: {
        saveDetail() {
            updateAgencyMenber(
                this.DetailInfo,
                this.$store.state.user.userinfo.id
            ).then(res => {
                if (res.status === 0) {
                    this.$message.success('修改成功')
                    this.$emit('update:showUpdate', false)
                }
            })
        }
    },
    watch: {
        showUpdate() {
            this.showDialog = this.showUpdate
        }
    }
}
</script>
